module.exports = __webpack_public_path__ + "img/juzzap-logo.957b4676.svg";